import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen relative bg-black">
      {/* Background image */}
      <div
        className="absolute inset-0 bg-cover bg-center filter blur-sm opacity-50"
        style={{ backgroundImage: 'url("/nails.jpeg")' }}
      ></div>

      {/* Glassmorphism login form with hover effect */}
      <div className="relative w-full max-w-md p-8 bg-white/10 backdrop-blur-md border border-white/30 rounded-xl shadow-lg
                      transition-transform duration-300 hover:scale-105 hover:-translate-y-1 hover:shadow-2xl">
        <h2 className="text-3xl font-bold mb-6 text-center text-white">Login</h2>
        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
          <div className="relative">
            <input
              type="email"
              id="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-2 text-white placeholder-transparent border-b border-white/50 focus:outline-none focus:border-pink-400 bg-transparent"
              placeholder="Enter your email"
            />
            <label
              htmlFor="email"
              className="absolute left-0 top-2 text-white text-sm pointer-events-none transition-all duration-150"
            >
              Enter your email
            </label>
          </div>

          <div className="relative">
            <input
              type="password"
              id="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-2 text-white placeholder-transparent border-b border-white/50 focus:outline-none focus:border-pink-400 bg-transparent"
              placeholder="Enter your password"
            />
            <label
              htmlFor="password"
              className="absolute left-0 top-2 text-white text-sm pointer-events-none transition-all duration-150"
            >
              Enter your password
            </label>
          </div>

          <div className="flex items-center justify-between text-white text-sm">
            <label className="flex items-center gap-2">
              <input type="checkbox" className="accent-pink-400" />
              Remember me
            </label>
            <Link to="#" className="hover:underline">
              Forgot password?
            </Link>
          </div>

          <button
            type="submit"
            className="w-full py-2 px-4 mt-4 bg-white/20 text-white font-semibold rounded-md hover:bg-white/30 transition"
          >
            Log In
          </button>
        </form>

        <p className="text-center text-white mt-6 text-sm">
          Don't have an account?{" "}
          <Link to="/signup" className="text-pink-400 hover:underline font-medium">
            Register
          </Link>
        </p>
      </div>
    </div>
  );
}
